import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { http } from "@/lib/api";
import { Calendar, User, ArrowLeft } from "lucide-react";

export function Blog() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    http.get("/blogs").then((r) => setBlogs(r.data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="blog-list">
      <div className="mb-10">
        <div className="text-xs font-mono text-[#D97706] uppercase tracking-wider">The Rasayana Journal</div>
        <h1 className="font-serif text-4xl sm:text-5xl font-bold text-[#1A201C] mt-1">Ayurveda, wellness & wisdom</h1>
        <p className="mt-2 text-[#5A6B5D] max-w-2xl">
          Doctor-authored notes from Dr. Rupali Srivastava, Amit Kumar Srivastava, and the Amiroop Healthion team.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {blogs.map((b) => (
          <Link
            key={b.id}
            to={`/blog/${b.slug}`}
            data-testid={`blog-card-${b.slug}`}
            className="card-warm overflow-hidden group flex flex-col"
          >
            <div className="aspect-[16/10] overflow-hidden bg-[#E8F0EA]">
              <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-5 flex-1 flex flex-col">
              <span className="badge-sage w-fit">{b.tag}</span>
              <h2 className="mt-3 font-serif text-2xl font-semibold text-[#1A201C] leading-snug group-hover:text-[#1E3A2B]">
                {b.title}
              </h2>
              <p className="mt-2 text-sm text-[#5A6B5D] line-clamp-3">{b.excerpt}</p>
              <div className="mt-4 pt-4 border-t border-[#E2DDD5] text-xs text-[#5A6B5D] font-mono flex items-center gap-3">
                <span className="flex items-center gap-1"><User className="w-3 h-3" /> {b.author}</span>
                <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {new Date(b.created_at).toLocaleDateString("en-IN", { month: "short", day: "numeric" })}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    http.get(`/blogs/${slug}`).then((r) => setBlog(r.data));
  }, [slug]);

  if (!blog) return <div className="p-10 text-center">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="blog-detail">
      <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-[#1E3A2B] font-semibold mb-6">
        <ArrowLeft className="w-4 h-4" /> All articles
      </Link>
      <span className="badge-sage">{blog.tag}</span>
      <h1 className="mt-4 font-serif text-4xl sm:text-5xl font-bold text-[#1A201C] leading-tight tracking-tight">{blog.title}</h1>
      <div className="mt-4 flex items-center gap-4 text-sm text-[#5A6B5D] font-mono">
        <span className="flex items-center gap-1"><User className="w-3.5 h-3.5" /> {blog.author}</span>
        <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {new Date(blog.created_at).toLocaleDateString("en-IN", { month: "long", day: "numeric", year: "numeric" })}</span>
      </div>

      <div className="mt-8 aspect-[16/9] rounded-3xl overflow-hidden border border-[#E2DDD5]">
        <img src={blog.cover_image} alt={blog.title} className="w-full h-full object-cover" />
      </div>

      <div className="mt-10 space-y-5 text-[#1A201C] leading-relaxed text-lg">
        {blog.content.split("\n\n").map((para, i) => (
          <p key={i}>{para}</p>
        ))}
      </div>
    </article>
  );
}
